/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_A4Inputs */

const en_to_csv_faq_a4 = /** @type {(inputs: To_Csv_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. A single object is treated as a one-row table, with keys as headers and values as the single data row.`)
};

const ko_to_csv_faq_a4 = /** @type {(inputs: To_Csv_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 단일 객체는 키가 헤더이고 값이 단일 데이터 행인 한 줄짜리 표로 처리됩니다.`)
};

const ja_to_csv_faq_a4 = /** @type {(inputs: To_Csv_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。単一のオブジェクトは1行のテーブルとして扱われ、キーがヘッダー、値がデータ行になります。`)
};

/**
* | output |
* | --- |
* | "Yes. A single object is treated as a one-row table, with keys as headers and values as the single data row." |
*
* @param {To_Csv_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_a4 = /** @type {((inputs?: To_Csv_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_a4(inputs)
	if (locale === "ko") return ko_to_csv_faq_a4(inputs)
	return ja_to_csv_faq_a4(inputs)
});